<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .history-item {
    display: flex;
    flex-direction: column;

    .title-and-date {
      display: flex;
      gap: utils.in_rem(8px);

      .title {
        @include mixins.body3-bold();
        @include colors.color(primary_90);
      }

      .date {
        @include mixins.body3();
        @include colors.color(textLighterBlack);
      }
    }

    .subtitle {
      @include mixins.body3();
      @include colors.color(textBlack);
    }

    .description {
      @include mixins.body3();
      @include colors.color(textLighterBlack);
    }
  }
</style>

<script>
  let { historyItem } = $props();
</script>

<div class="history-item">
  <div class="title-and-date">
    <span class="title">{historyItem.title}</span>
    <span class="date">{historyItem.dateRange}</span>
  </div>
  <span class="subtitle">{historyItem.subtitle}</span>
  <span class="description">{historyItem.description}</span>
</div>
